"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HintValue = exports.HintItem = exports.HintHeader = exports.HintDot = exports.HintBox = exports.HintBody = exports.FillAvailableSpace = exports.ExpectedIcon = exports.Container = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _colors = require("../../constants/colors");

var _colors2 = require("./colors");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HintBox = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: white;\n  box-shadow: 0px 15px 12px rgba(178, 173, 166, 0.21);\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  color: black;\n  font-size: 14px;\n"])));

exports.HintBox = HintBox;

var HintHeader = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  color: white;\n  display: flex;\n  font-weight: bold;\n  height: 48px;\n  justify-content: center;\n"])), function (props) {
  return props && props.color ? props.color : _colors.NAVY;
});

exports.HintHeader = HintHeader;

var HintBody = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 12px;\n"])));

exports.HintBody = HintBody;

var HintValue = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 6px;\n"])));

exports.HintValue = HintValue;

var FillAvailableSpace = _styled["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));

exports.FillAvailableSpace = FillAvailableSpace;

var Container = _styled["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n"])));

exports.Container = Container;

var HintDot = _styled["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 10px;\n  margin-right: 10px;\n  height: 10px;\n  border-radius: 5px;\n  display: inline-block;\n"])));

exports.HintDot = HintDot;
var ExpectedIcon = (0, _styled["default"])(HintDot)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  border: 1px dashed ", ";\n"])), _colors2.START_GRADIENT);
exports.ExpectedIcon = ExpectedIcon;

var HintItem = _styled["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 8px 0 0 0;\n  width: 100%;\n"])));

exports.HintItem = HintItem;